import { Typography, useTheme } from '@mui/material';
import { BoxHoverCursor } from './boxes';

export const HeaderTab = ({
                            isActive,
                            onClick,
                            text
                          }: { isActive: boolean, onClick: () => void, text: string }) => {
  const theme = useTheme();
  return (
    <BoxHoverCursor width={'100%'} textAlign={'center'} py={1} onClick={onClick}
                    sx={{ background: isActive ? theme.palette.primary.main : theme.palette.background.default }}>
      <Typography variant={'h6'}
                  sx={{ color: isActive ? theme.palette.background.default : theme.palette.primary.main }}>
        {text}
      </Typography>
    </BoxHoverCursor>
  );
};